import { BlogNavigation } from '@we-make-websites/ui-lib';
import type { BlogNavigationProps } from '@we-make-websites/ui-lib';
import clsx from 'clsx';
import { useContext } from 'use-context-selector';
import { BlogArticleContext } from 'components/blogArticleProvider/BlogArticleProvider';
import { BlogLandingContext } from 'components/blogLandingProvider/BlogLandingProvider';
import { BlogCategoryContext } from 'components/blogsCategoryProvider/BlogCategoryProvider';

import styles from './BlogArticleNavigation.module.scss';

export const BlogLandingNavigation = () => {
  const blogLandingContext = useContext(BlogLandingContext);

  if (blogLandingContext === undefined) {
    throw new Error(
      'BlogLandingNavigation must be used within a BlogLandingContext'
    );
  }

  const { navigation } = blogLandingContext;

  return <BlogNavigationContent navigation={navigation} />;
};

export const BlogCategoryNavigation = () => {
  const blogCategoryContext = useContext(BlogCategoryContext);

  if (blogCategoryContext === undefined) {
    throw new Error(
      'BlogCategoryNavigation must be used within a BlogCategoryContext'
    );
  }

  const { navigation } = blogCategoryContext;

  return <BlogNavigationContent navigation={navigation} />;
};

export const BlogArticleNavigation = () => {
  const blogArticleContext = useContext(BlogArticleContext);

  if (blogArticleContext === undefined) {
    throw new Error(
      'BlogArticleNavigation must be used within a BlogArticleContext'
    );
  }

  const { navigation } = blogArticleContext;

  if (!navigation) return <></>;

  return (
    <div className={styles.blogArticleNavigation__wrapper}>
      <p className="text-heading-h5-mobile text-heading-h5-desktop container">
        {navigation?.heading}
      </p>
      <BlogNavigationContent
        navigation={navigation}
        className={clsx(styles.blogArticleNavigation, 'container')}
      />
    </div>
  );
};

const BlogNavigationContent = ({
  navigation,
  className,
}: {
  navigation?: BlogNavigationProps;
  className?: string;
}) => {
  if (!navigation) return <></>;

  return <BlogNavigation {...navigation} className={className} />;
};
